import { Clock, MapPin, Pin } from "lucide-react";
import { KIND, formatDate, timeRange } from "@/lib/dates";
import { StatusTag } from "./EventStatus";

export const EventItem = ({ event, children }) => (
  <div className={`card event-card space-y-2 ${event.status === "canceled" ? "event-canceled" : ""}`} style={{ "--kind": event.status === "scheduled" ? KIND[event.kind].color : "#dc2626" }} data-testid="event-item">
    <StatusTag event={event} />
    <div className="flex flex-wrap items-start justify-between gap-x-3 gap-y-1">
      <div className="min-w-0 flex-1 basis-40">
        <span className="kind-chip" data-testid="event-kind">{KIND[event.kind].label}</span>
        <h3 className="font-heading text-2xl font-extrabold uppercase leading-tight mt-1 break-words" data-testid="event-title">{event.title}</h3>
      </div>
      <div className="sm:text-right shrink-0">
        <p className="font-heading text-xl font-extrabold uppercase whitespace-nowrap" data-testid="event-date">{formatDate(event.date)}</p>
        <p className="font-bold text-sm flex items-center gap-1 sm:justify-end whitespace-nowrap" data-testid="event-time"><Clock size={14} />{timeRange(event)}</p>
      </div>
    </div>
    {event.location && (
      <a className="inline-flex items-center gap-1 font-semibold underline" target="_blank" rel="noreferrer" data-testid="event-location"
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.location)}`}>
        <MapPin size={16} />{event.location}
      </a>
    )}
    {event.notes && <p className="font-medium text-[var(--muted)] whitespace-pre-line" data-testid="event-notes">{event.notes}</p>}
    <p className="text-sm font-bold" data-testid="event-counts">
      {event.counts.yes} going · {event.counts.maybe} maybe · {event.counts.no} can't make it
    </p>
    {children}
  </div>
);

export const AnnouncementItem = ({ a, children }) => (
  <div className={`card space-y-1 ${a.pinned ? "ann-pinned" : ""}`} data-testid="announcement-item">
    <div className="flex items-start justify-between gap-2">
      <h3 className="font-heading text-xl font-extrabold uppercase flex items-center gap-1.5" data-testid="announcement-title">{a.pinned && <Pin size={18} className="text-[#ca8a04]" />}{a.title}</h3>
      {children}
    </div>
    <p className="font-medium whitespace-pre-line" data-testid="announcement-body">{a.body}</p>
    <p className="text-xs font-semibold text-[var(--muted)]">{new Date(a.created_at).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}</p>
  </div>
);
